import { Currency } from '@/core/currency/interfaces';

const ANG: Currency = {
    name: 'Netherlands Antillean Guilder',
    demonym: 'Netherlands Antillean',
    majorSingle: 'Guilder',
    majorPlural: 'Guilders',
    codeNumeric: '532',
    symbol: 'ƒ',
    symbolNative: 'ƒ',
    minorSingle: 'Cent',
    minorPlural: 'Cents',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'ANG',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default ANG;
